import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiServices } from 'src/app/shared/api.services';
import { NgForm } from '@angular/forms';
import { ApiSocket } from 'src/app/shared/api.socket';


@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit {
  base_url: string;
  title: string = "Chat Support";
  openChats = [];
  existingChats = [];
  stats = [];
  isParent = true;
  userList: any;
  user_id: string = "";
  chat_status: string = "";
  thing_type: string;
  search_key: string = '';
  socket: SocketIOClient.Socket;

  //scroll lazy pagination
  start = 0;
  skip = 0;
  selector: string = '.chat-panel';
  loadUsers: boolean = false;
  isScrollEnd: boolean = false;

  constructor(public apiServices: ApiServices, private router: Router, private apiSocket: ApiSocket) {
    this.base_url = apiServices.base_url;
    this.socket = apiSocket.socket;
  }

  ngOnInit() {
    /* if (this.apiServices.localStorageItem('role') == 'support') {
      this.thing_type = 'academy';
    } else {
      this.thing_type = 'job';
    } */
    this.thing_type = "general";
    this.getUsers().then(userdata => {
      this.userList = userdata['data'];
    });
    this.initSokets();
    this.getChatHeads(this.skip);
  }

  initSokets() {
    this.socket.on('support_' + this.thing_type + '_open', (open: any) => {
      if (open.by == 'user')
        this.playAudio();
      let id = this.findObjectByKey(this.openChats, 'uniq_id', open['uniq_id']);
      if (id >= 0) {
        this.openChats[id] = open;
      } else {
        this.openChats.push(open);
      }
      this.openChats.sort((a, b) => a.created_at > b.created_at ? -1 : a.created_at < b.created_at ? 1 : 0)
    });
    this.socket.on('support_' + this.thing_type + '_existing', (existing: any) => {
      if (existing.by == 'user')
        this.playAudio();
      let id = this.findObjectByKey(this.existingChats, 'uniq_id', existing['uniq_id']);
      if (id >= 0) {
        this.existingChats[id]['message'] = existing['message'];
        this.existingChats[id]['created_at'] = existing['created_at'];
      } else {
        let open_id = this.findObjectByKey(this.openChats, 'uniq_id', existing['uniq_id']);
        if (open_id >= 0) {
          this.openChats.splice(open_id, 1);
        }
        this.existingChats.push(existing);
      }
      this.existingChats.sort((a, b) => a.created_at > b.created_at ? -1 : a.created_at < b.created_at ? 1 : 0)
    });
  }

  getChatHeads(skip: number = 0, user_id: string = '', chat_status: string = '', is_scroll = false) {
    this.isScrollEnd == false
    this.skip = skip;
    this.router.navigate(['/chat']);
    let params = {};
    this.user_id = user_id;

    if (user_id != '') {
      params['user_id'] = this.user_id;
    }
    this.chat_status = chat_status;
    if (this.chat_status != '') {
      if (this.chat_status == "unsolved") {
        params['solved'] = false;
      } else {
        params['solved'] = true;
      }
    }
    params['skip'] = skip;
    params['thing_type'] = this.thing_type;
    if (this.search_key != '') {
      params['search_key'] = this.search_key;
    }
    this.apiServices.getChatHeads(params).subscribe(chats => {
      if (chats['openChats']) {
        this.openChats = chats['openChats'];
      }

      if (chats['existingChats']) {
        if (this.skip > 0 && chats['existingChats'].length == 0) {
          this.isScrollEnd = true;
        } else {
          if (is_scroll == true && this.search_key == '') {
            chats['existingChats'].forEach(chat => {
              this.existingChats.push(chat);
            });
          } else {
            this.existingChats = chats['existingChats'];
          }
          this.isScrollEnd = false;
        }
      }
      if (chats['stats']) {
        this.stats = chats['stats'];
      }
      this.loadUsers = false;
    });
  }

  findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return i;
      }
    }
    return -1;
  }

  playAudio() {
    let audio = new Audio();
    audio.src = "assets/beep.mp3";
    audio.load();
    setTimeout(() => {
      audio.play();
    }, 100);
  }

  getUsers() {
    /* let role = 'support';
    if (this.thing_type == 'job' || this.thing_type == 'recruitment') {
      role = 'jobManager';
    } */
    let role = 'admin';
    return new Promise((resolve, reject) => {
      this.apiServices.getUsers({ 'role': role }).subscribe(users => {
        resolve(users);
      })
    })
  }

  getUserDropdown(thing_type: string) {
    this.thing_type = thing_type;
    this.router.navigate(['/chat']);
    this.initSokets();
    this.getChatHeads(this.skip);
    this.getUsers().then(userdata => {
      this.userList = userdata['data'];
    });
  }

  onScrollDown() {
    if (this.isScrollEnd == false) {
      this.loadUsers = true;
      this.skip += 10;
      this.getChatHeads(this.skip, this.user_id, this.chat_status, true);
    }

  }

  searchChatHeads(form: NgForm) {
    this.search_key = form.value.search_key;
    this.getChatHeads(0, this.user_id, this.chat_status, true);
  }

}
